import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import CardsPage from "./pages/CardsPage";
import ImportCsvPage from "./pages/ImportCsvPage";
import ImportVcfPage from "./pages/ImportVcfPage";
import ManualEntryPage from "./pages/ManualEntryPage";
import SettingsPage from "./pages/SettingsPage";
import { useAuthStore } from "./lib/auth";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const accessToken = useAuthStore((s) => s.accessToken);
  if (!accessToken) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/cards"
        element={
          <ProtectedRoute>
            <CardsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/import/csv"
        element={
          <ProtectedRoute>
            <ImportCsvPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/import/vcf"
        element={
          <ProtectedRoute>
            <ImportVcfPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/manual"
        element={
          <ProtectedRoute>
            <ManualEntryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
